<template>
  <div class="home">
     <div class="headbox" style="position: relative;">
       <div class="header">
         <img src="@/assets/img/logo.svg" class="logo"/>
         <div class="blo1"></div>
         <div class="navbox" v-if="visible || isPC" @click="visible=false">
           <router-link v-for="(v, k) in navList" :class="'item ' + (navCur == k ? 'cur' : '')" tag="div" :to="{'name':v.link,'query':v.query}"> {{ v.tit }}
           </router-link>
         </div>
         <div class="blo2"></div>
         <a :href="'/apply/#/?'+query" target="_blank" class="appbtn">商家入驻</a>
         <div class="menu" @click="visible=true"></div>
       </div>
     </div>
     <div class="banner" id="banner" v-if="isPC">
       <!-- <img src="@/assets/img/home/banner.png" width="100%" class="pcban" v-if="isPC" />
       <img src="@/assets/img/mobile/mban.png" width="100%" class="mban"  v-else /> -->
     </div>
     <div class="swiper-container banner"  id="mban" v-else>
        <!-- <img src="@/assets/img/mobile/mban.jpg" width="100%" class="mban"/> -->
        <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="i in 4">
              <img :src="'https://dyuit-front.oss-cn-hangzhou.aliyuncs.com/rules/mban'+i+'.jpg'" width="100%"/>
            </div>
        </div>
     </div>
     <div class="navs" :class="{'fixed':oftop.fixed}" v-if="isPC">
       <a href="javascript:void(0);" v-for="(item, index) in nav"  :class="{'cur':index==oftop.cindex}" @click="link(index)">{{ item }}</a>
     </div>
     <div class="about" id="conbox0">
       <img src="https://dyuit-front.oss-cn-hangzhou.aliyuncs.com/rules/mobile.png" class="phone" ref="phone" />
       <div class="rt">
         <div class="htit">
           <img :src="require(`@/assets/img/home/${isPC?'':'m'}htit1.png`)" alt="">
         </div>
         <ul>
           <li>
             <div class="tit">政企AI采销</div>
             <div class="say">“国采云”平台是由中国科学院深圳先进技术研究院旗下产业运营平台“深科高新”与国家高新技术企业“点宇科技”共同打造的数字创新国有背景采销一体云平台。</div>
           </li>
           <li>
             <div class="tit">私域模式为主</div>
             <div class="say">国采云以私域模式为主，商品品质、用户体验是国采云秉承的原则之一，以高质量服务保障客户需求。</div>
           </li>
           <li>
             <div class="tit">强大的技术体系</div>
             <div class="say">在技术保障方面，支撑全国亿级用户使用高并发场景，为商家和用户提供平台安全、稳定、不间断运行的技术保障。</div>
           </li>
         </ul>
         <div class="bot">
           <ol>
             <li>
               <div class="nums" id="num1"><b>0</b> <span>+</span></div>
               <div class="tit">服务政企单位</div>
             </li>
             <li>
               <div class="nums" id="num2"><b>0</b> <span>+</span></div>
               <div class="tit">服务职工</div>
             </li>
             <li>
               <div class="nums" id="num3"><b>0</b> <span>+</span></div>
               <div class="tit">覆盖城市</div>
             </li>
             <li>
               <div class="nums" id="num4"><b>0</b><span>+</span></div>
               <div class="tit">专利及软著</div>
             </li>
           </ol>
         </div>
       </div>
     </div>
     <div class="content advantage" id="conbox1">
       <div class="htit">
        <img :src="require(`@/assets/img/home/${isPC?'':'m'}htit2.png`)" alt="">
       </div>
       <div class="cterbox">
         <ul>
           <li>
             <div class="tit">超规模生态体系</div>
             <div class="say">平台整合了超体量的高品质、强服务的生态供应体系，<br/> 构建了用户的高频消费场景。
             </div>
           </li>
           <li>
             <div class="tit">政企客户资源</div>
             <div class="say">平台政企客户资源覆盖政府机构、国央企、大型集团企业，精准对接<br/>高频采购需求。 </div>
           </li>
           <li>
             <div class="tit">平台服务保障</div>
             <div class="say">资质全链审核，包括工信部、商务厅、市监局等多部门认证，为平台<br/>提供强有力的信誉背书。</div>
           </li>
         </ul>
         <div class="piclist">
           <img :src="require('@/assets/img/home/pp'+i+'.png')" v-for="i in 12" />
           <div class="ltit">超规模生态</div>
         </div>
       </div>
       <div class="mhtit">多维消费场景</div>
       <div class="longbox">
        <div class="swiper-container mySwiper">
          <div class="swiper-wrapper ul">
            <div v-for="i in advantage" class="li swiper-slide">
              <img :src="require('@/assets/img/home/can'+i.img+'.png')" />
              <div class="tit">{{ i.tit }}</div>
            </div>
          </div>
        </div>
       </div>
     </div>
    <div class="content process" id="conbox2">
      <div class="htit">
        <img :src="require(`@/assets/img/home/${isPC?'':'m'}htit3.png`)" alt="">
      </div>
      <ul>
        <li v-for="(i,index) in ailist">
            <img :src="require('@/assets/img/home/ai'+i.img+'.png')"/>
            <div class="mhtit" v-if="!isPC">0{{index+1}}.</div>
            <div class="tit">{{ i.tit }}</div>
            <div class="say" v-html="i.say"></div>
            <a :href="i.href" v-if="i.href" target="_blank">{{ i.hrefName }}</a>
        </li>
        <li class="last" v-if="!isPC">
          <img src="@/assets/img/home/ik6.png" />
          <a :href="'/apply/#/?'+query" class="go">马上入驻</a>
        </li>
      </ul>
    </div>
     <div class="content funbox" id="conbox3">
       <div class="htit">
        <img :src="require(`@/assets/img/home/${isPC?'':'m'}htit4.png`)" alt="">
       </div>
       <ul>
         <li v-for="(i,index) in funlist" :style="{'backgroundImage':'url('+require('@/assets/img/home/fun'+i.img+'.png')+')'}">
           <div class="tit">{{ i.tit }}</div>
           <div class="say" v-html="i.say" :class="{'sml':index==1}"></div>
         </li>
       </ul>
     </div>
     <div class="content brand" id="conbox4">
       <div class="htit">
        <img :src="require(`@/assets/img/home/${isPC?'':'m'}htit5.png`)" alt="">
       </div>
       <vue-seamless-scroll :data="piclist" class="list" :classOption="brandOption">
        <ul>
          <li v-for="i in piclist">
              <img :src="require('@/assets/img/home/pp/pic'+i+'.png')" alt="">
          </li>
        </ul>
        </vue-seamless-scroll>
     </div>
     <div class="content cooperate" id="conbox5">
        <div class="htit"><img :src="require(`@/assets/img/home/${isPC?'':'m'}htit6.png`)" alt=""></div>
        <div class="kbox">
          <div class="lfbox">
            <ul>
              <li>
                <span>政府部门：</span>
                省政府、市政府、民政厅、公安厅、农业厅、安全厅、退役军人事务厅、卫健委、教育局、执法局、水利局、市纪委等 
              </li>
              <li>
                <span>国央企：</span>
                中建、中交、中航材、中食网、中国诚通、中国电子、中国移动、物产中大、城投集团、城市学院、春蕾教育、杭二中、杭州口腔医院等 
              </li>
              <li>
                <span>企业集团：</span>
                比亚迪、正泰、德力西、每日互动、亚联飞行、胜达集团、中国服装城、钱江电气等大型企业集团和上市公司企业
              </li>
            </ul>
          </div>
          <div class="swiper-containers overbox">
            <!-- <vue-seamless-scroll :data="coolist" class="list">
              <ul>
                <li v-for="i in coolist">
                    <img :src="require('@/assets/img/home/cooperate/pic'+i+'.png')" alt="">
                </li>
              </ul>
            </vue-seamless-scroll> -->
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="i in coolist" :key="i">
                  <div class="l" v-for="j in i" :key="j">
                    <img :src="require('@/assets/img/home/cooperate/pic'+j+'.png')" alt=""/>
                  </div>
                </div>
            </div>

          </div>
        </div>
     </div>
     <div class="nfooter">
      <a :href="'/apply/#/?'+query" class="link">立即入驻</a>
      <div class="content bots">
        <div class="htit">让每一次选择<br>都满载关怀与价值！</div>
        <ul>
          <li>
              <div class="tit">国有背景</div>
              <div class="say">
                中国科学院深圳先进技术研究院、 <br />“深科高新”旗下AI采销服务云平台
              </div>
            </li>
            <li>
              <div class="tit">数据安全</div>
              <div class="say">
                非对称加密算法+区块链存证，<br />确保用户信息安全
              </div>
            </li>
            <li>
              <div class="tit">国家高新</div>
              <div class="say">
                国家级高新技术企业，专业高效的<br />技术团队
              </div>
            </li>
            <li>
              <div class="tit">品质保障</div>
              <div class="say">
                整合国内头部电商资源及源头品牌<br />供应商
              </div>
            </li>
        </ul>
        <div class="last">
          Copyright © 2025 <a href="https://www.casdt.cn" target="_blank">casdt.cn </a> <a target="_blank" href="https://beian.miit.gov.cn/">浙ICP备2024140619号-1</a>
          中科国采(浙江自贸区)技术发展有限公司 <br>
          All Rights Reserved 中科国采(浙江自贸区)技术发展有限公司版权所有 BY：中科国采<br>
          银行监管 ｜ 出版物经营许可证 ｜ 增值电信业务经营许可证 ｜ 食品经营许可证 ｜ 第二类医疗器械经营备案 ｜ 互联网药品信息服务资格证
<!-- 
        <p>Copyright © 2020 <a href='www.casdt.cn' target="_blank">casdt.cn</a>. <a target="_blank" href="https://beian.miit.gov.cn/" >浙ICP备18031042号</a> 中科国采(浙江自贸区)技术发展有限公司浙公网安备 33010602010714号</p>  
        <p>All Rights Reserved 中科国采(浙江自贸区)技术发展有限公司版权所有  BY：中科国采</p>  
        <p>银行监管 ｜ 出版物经营许可证 ｜ 增值电信业务经营许可证 ｜ 食品经营许可证 ｜ 第二类医疗器械经营备案  ｜ 互联网药品信息服务资格证</p>   -->
        </div>
      </div>
     </div>
   </div>
 </template>
 <script>
  import { advantage,funlist,ailist,animateNumber,animate,createFragments,checkDeviceEnhanced} from './index'
  import vueSeamlessScroll from 'vue-seamless-scroll'
  import Swiper from "swiper";
  import "swiper/dist/css/swiper.min.css";
  import scrollReveal from 'scrollreveal';
  import wx from 'jweixin-1.6.0';
  var mySwiper
   export default {
      components: {
        vueSeamlessScroll
      },
      data() {
       return {
         scrollReveal: scrollReveal(),
         curIndex:0,
         fun:null,
         searchSelected:'',
         searchName:'',
         oftop:{
          cindex:0,
          fixed:false,
          top:0,
          over:true
         },
         coolist:[[1,2,3,'3_1',4,5,6,7,8,9,10,11],[12,13,14,15,16,17,18,19,20,21,22,23],[24,25,26,27,28,'28_1','28_2','28_3',29,30,31,32]],
         piclist:[1,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40],
         funlist,
         ailist,
         advantage,
         navCur: 0,
         brandOption:{
          direction: 2,
         },
         visible:false,
         isPC:true,
         navList: [
          {tit:'招商中心',link:'home'},
          {tit:'规则中心',link:'list'},
          {tit: '帮助中心',link:'list',query:{fkey:1,key:'0-0'}}
         ],
         nav: ['平台概况', '平台优势', '入驻流程', '入驻政策', '入驻品牌', '合作客户'],
         query:this.jsonToUrlParam(this.$route.query),
       }
     },
     created() {
      if(this.query){
        localStorage.setItem('query',this.query)
      }
     },
     mounted() {
       this.updateWindowWidth()
       window.addEventListener('resize', this.updateWindowWidth);
       window.addEventListener('scroll', this.scroll);
       setTimeout(() => {
        mySwiper = new Swiper(".mySwiper", {
          slidesPerView:this.isPC?3:2,
          paginationClickable: true,
          spaceBetween: this.isPC?30:15,
          speed:1600,
          autoplay: {
            delay:2000
          },
          autoplayDisableOnInteraction: false,
          loop: true,
        });
         new Swiper('.overbox', {
          effect: 'cube',
          speed:800,
          autoplay:3000,
        //  grabCursor: true,
          autoplayDisableOnInteraction: false,
          circular: true,
          loop:checkDeviceEnhanced(),
        });
        
    
        if(this.isPC){
          createFragments(this.curIndex)
            this.fun=setInterval(() => {
              this.curIndex=this.curIndex==3?0:this.curIndex+1
              createFragments(this.curIndex)
           }, 5000);
          animate(this.scrollReveal)
        }
      }, 100)
      if(!this.isPC){
        animateNumber(10000,2000,'num1')
        animateNumber(5000000,3000,'num2')
        animateNumber(300,2000,'num3')
        animateNumber(100,2000,'num4')
        setTimeout(()=>{
          new Swiper('#mban', {
            speed:800,
            autoplay: 3000,
            autoplayDisableOnInteraction: false,
            loop: true,
          });
        },100)
      }
      fetch('https://service.casdt.cn/api/wxapp/jssdkSign', {
          method: 'POST', 
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify({
              wxapp_id: 10008,
              url: window.location.href
          })
      })
      .then(response => response.json()) // 将响应数据解析为 JSON
      .then(data => {
          console.log(data)
          const { appId, nonceStr, signature, timestamp } = data.data.sign; 
          wx.config({
              debug: false, // 是否开启调试模式
              appId: appId, // 必填，公众号的唯一标识
              timestamp: timestamp, // 必填，生成签名的时间戳
              nonceStr: nonceStr, // 必填，生成签名的随机串
              signature: signature, // 必填，签名
              jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"] // 需要使用的 JS 接口列表
          });
      })
      .catch(error => {
          console.error('Error fetching data:', error); // 在控制台输出错误信息
      });

      const title = '国采云-商家入驻服务', desc = '工信部备案AI采销一体电商平台，政企单位专业采销服务机构', url = window.location.href, shareImg = 'http://dyuit-front.oss-cn-hangzhou.aliyuncs.com/active/share/part/nshare.png'
      wx.ready(function () {
        const shareObject = {
          title: title,
          desc: desc,
          link: url,
          imgUrl: shareImg,
          success: function () {
            console.log("");
          },
          cancel: function () {
            console.log("");
          },
          fail: function () {
            console.log("");
          }
        };
        wx.updateAppMessageShareData(shareObject);
        wx.updateTimelineShareData(shareObject);
      });
     },
     computed:{
     
     },
     methods:{
      jsonToUrlParam(json) {
        return Object.keys(json).map(key => key + '=' + json[key]).join('&');
      },
      updateWindowWidth(){
        this.isPC= document.body.clientWidth> 1260
       
        if(!this.isPC){
          clearInterval(this.fun)
          this.fun=null;
        }else{
          document.getElementById('banner').innerHTML = '';
        }
      },
      setCur(index) {
     
      },   
      link(index){
        const targetElement = index === 0 ? 0 : document.getElementById('conbox' + index).offsetTop - 120;
        window.scrollTo({
          top: targetElement,
          behavior: 'smooth'
        });
      },  
      scroll() {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        const winHei = (window.innerHeight || document.documentElement.clientHeight) / 2;
        if(this.oftop.top==0 && this.isPC){
          const bantop=document.querySelector('.navs').offsetTop;
          this.oftop.top=bantop
        }
        const elements = {
            'conbox0': 0,
            'conbox1': 1,
            'conbox2': 2,
            'conbox3': 3,
            'conbox4': 4,
            'conbox5': 5,
        };
        for (const [id, value] of Object.entries(elements)) {
          const element = document.getElementById(id);
          if (scrollTop + winHei >= element.offsetTop) {
              this.oftop.cindex = value;
            }
          }
          if(scrollTop>this.oftop.top && this.oftop.over){
            animateNumber(10000,2000,'num1')
            animateNumber(5000000,2000,'num2')
            animateNumber(300,2000,'num3')
            animateNumber(100,2000,'num4')
            this.oftop.over=false;
          }
          this.oftop.fixed=scrollTop > this.oftop.top
        },
     }
   }
 </script>
 <style lang="less" scoped>
   @import "@/assets/css/header.less";
   @import "./index.less";
 </style>